import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { FlutterBridgeService } from '../../core/services/flutter-bridge/flutter-bridge.service';
import { GetTrxStatusUsecase } from '../../core/usecase/fs-wallet-qris/get-trx-status.usecase';

@Component({
  selector: 'wallet-qris-trx-status',
  templateUrl: './wallet-qris-trx-status.component.html',
  styleUrls: ['./wallet-qris-trx-status.component.scss'],
})
export class WalletQrisTrxStatusComponent {
  wallet_id: string = '';
  status: "SUCCESS" | "FAILED" | 'PENDING'  = 'PENDING';
  isLoading = false;
  token: string = '';
  token_data: any = null;
  data: any = null;
  lang: string = 'id';
  statusMessageVisible = false;
  contactCSUrl = 'https://api.whatsapp.com/send?phone=6285219526186&text=Halo%20tim%20CS%20Paper.id%2C%20saya%20memiliki%20pertanyaan%20tentang%20Paper%20Horizon%20Wallet'


  private readonly ngUnsubsribe$ = new Subject<void>();

  public displayStatus() {
    return this.status.toLowerCase();
  }

  public severity() {
    let severity = '';
    switch ( this.status ) {
      case 'SUCCESS':
        severity = 'success';
        break;
      case 'FAILED':
        severity = 'error'
        break;
      default: 
        severity = 'info'
        break;
   }
   return severity;
  }

  constructor(
    private readonly activeRouter: ActivatedRoute,
    private readonly getTrxStatusUsecase: GetTrxStatusUsecase,
    private readonly messageService: MessageService,
    private readonly translateService: TranslateService,
    private readonly flutterBridgeService: FlutterBridgeService,
    private readonly cdr: ChangeDetectorRef,
    public router: Router
  ) {
    this.token =
      this.router.getCurrentNavigation()?.extras?.state?.['token'] || {};
    this.data =
      this.router.getCurrentNavigation()?.extras?.state?.['data'] || {};
    this.token_data =
      this.router.getCurrentNavigation()?.extras?.state?.['token_data'] || {};
    this.activeRouter.queryParamMap.subscribe((params) => {
      this.lang = params.get('lang')!;
    });
  }

  ngOnInit(): void {
    if(this.token && this.data && this.token_data) {
      this.getTrxStatus();
    }
  }

  async poolTrxStatus() {
    await new Promise(resolve => setTimeout(resolve, 15000));
    this.getTrxStatus();
  }

  getTrxStatus() {
    this.clearStatusMessage()
    const data = {
      wallet_id: this.token_data?.wallet_id,
      company_id: this.token_data?.client_ref_id,
      user_id: this.token_data?.user_ref_id,
      token: this.token,
      transaction_id: this.data.id
    };
    this.getTrxStatusUsecase
      .execute(data)
      .pipe(takeUntil(this.ngUnsubsribe$))
      .subscribe({
      next: (res) => {
        this.status = res.data?.status ?? "PENDING";
        this.showStatusMessage(this.severity());
        if(this.status === 'PENDING') {
          this.poolTrxStatus();
        }
      },
      error: (err) => {
        this.isLoading = false;

        const error_detail =
          this.translateService.instant('messages.error');
        this.messageService.add({
          severity: 'error',
          detail: error_detail,
          life: 5000,
        });

        this.poolTrxStatus();
      },
      complete: () => {
        this.cdr.detectChanges();
      }
      });
  }

  showStatusMessage(severity: string) {
    if (!this.statusMessageVisible) {
      this.messageService.add({ 
        key: 'trx-status', 
        sticky: false, 
        severity: severity,
        life: 5000, 
       });
      this.statusMessageVisible = true;
    }
  }

  clearStatusMessage() {
        this.messageService.clear('trx-status');
        this.statusMessageVisible = false;
    }

  viewTrxDetail() {
    this.flutterBridgeService.sendTrxSuccess(this.data.id, this.status);
  }

  backToScanner() {
    this.router.navigate([''], {
      queryParams: { lang: this.lang, token: this.token },
    });
  }
}
